// The business's time zone (4.3d.4) — one picker for the setup wizard, the working hours and the settings card. Every time in
// the app is read and shown in it (src/utils/times.js), and the assistant keeps its hours by it, so it is chosen once, here.
import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TZ_OPTIONS, browserZone, tzLabel } from "../../utils/timeZones";

export default function TimeZonePicker({ value, onChange, label, id, sx }) {
  const { t } = useTranslation("createplan");
  const options = value && !TZ_OPTIONS.includes(value) ? [value, ...TZ_OPTIONS] : TZ_OPTIONS;
  return (
    <Autocomplete
      id={id}
      options={options}
      value={value || browserZone()}
      onChange={(_, v) => v && onChange(v)}
      getOptionLabel={tzLabel}
      disableClearable
      size="small"
      sx={sx}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={t("timezoneSearchPlaceholder")}
          sx={{ "& .MuiInputBase-root": { fontFamily: "var(--font-ui)", fontSize: "var(--t-body-sm)", borderRadius: "var(--r-sm)" } }}
        />
      )}
    />
  );
}
